<rt-icons-container></rt-icons-container>
<div class="filler"></div>
<div class="app-loader">
  <div class="app-loader-sidebar-menu">
    <div class="menu-items" style="">
      <div class="menu-items-top-wrapper">
        <div class="menu-item"></div>

        <div class="menu-item"></div>

        <div class="menu-item"></div>
      </div>
      <div class="menu-items-bottom-wrapper">
        <div class="menu-item"></div>
      </div>
    </div>
  </div>

  <div class="app-loader-header-menu">
    <div class="header-wrapper">
      <div class="top-left">
        <div class="logo"></div>
      </div>
      <div class="top-center quick-search-container">
        <div></div>
      </div>
      <div class="top-right">
        <div class="mock-careers"></div>
        <div class="mock-referrals"></div>
        <div class="spacer"></div>
        <div class="mock-notification"></div>
        <div class="mock-avatar"></div>
      </div>
    </div>
  </div>

  <div id="component-outlet" class="app-loader-content">
    <div class="loading-info">
      <rt-spinner *ngIf="loading"></rt-spinner>
      <rtc-detached-router-outlet></rtc-detached-router-outlet>
    </div>
  </div>
</div>

<div class="fab-container">
  <div class="fab-new">
    <div></div>
  </div>
  <div class="fab-help">
    <div></div>
  </div>
</div>
